import React, { useEffect, useState } from "react";
import NavbarVisitor from "../Component/NavbarVisitor";
import { useParams } from "react-router-dom";
import axios from "axios";
import { BASE_URL, IMAGE_URL } from "../Component/Baseurl"; // Assuming IMAGE_URL is also imported from your base URL file
import Footer from "../Component/Footer";
import defaultlogo from "../Component/img/profile.webp";
import { Helmet } from "react-helmet";
import logo from "../Component/img/logo.png";
import { MapPin, Radio } from "react-feather";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar, faStarHalfAlt } from "@fortawesome/free-solid-svg-icons";
import PageViewCount from "../Component/PageViewCount";
import AllreviewComp from "../Component/AllreviewComp";

const AllPartners = () => {
  const { slug } = useParams();
  const [eventData, setEventData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedIndustries, setSelectedIndustries] = useState([]);
  const [selectedFollower, setSelectedFollower] = useState(null);
  const [reviews, setReviews] = useState(null);
  const [partners, setPartners] = useState([]); 

  useEffect(() => {
    const fetchEventDetails = async () => {
      try {
        const response = await axios.get(`${BASE_URL}GetExhibitionsBySlug/${slug}`);
        const { exhibition, industries, followCount, reviews } = response.data;

        setEventData(exhibition);
        setSelectedIndustries(industries.map((industry) => industry.industry));
        setSelectedFollower(followCount);
        setReviews(reviews);
        setLoading(false);

        // Fetch partners using the exhibition_unique_id
        const partnersResponse = await axios.get(`${BASE_URL}getPartners/${exhibition.exhibition_unique_id}`);
        console.log("Partners API Response:", partnersResponse.data); // Log the API response
        if (partnersResponse.data.success) {
          setPartners(partnersResponse.data.partners); // Set partners data
        }

      } catch (error) {
        console.error("Error fetching event details", error);
        setLoading(false);
      }
    };

    fetchEventDetails();
  }, [slug]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      weekday: "long",
      month: "long",
      day: "numeric",
      year: "2-digit",
    });
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
        <span className="loader"></span>
        <p className="ms-3">Loading Content...</p>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>{eventData.exhibition_name}</title>
        <meta name="description" content="Explore upcoming events, conferences, and more on Evventoz." />
        <meta property="og:title" content={eventData.exhibition_name} />
        <meta property="og:image" content={logo} />
        <meta property="og:url" content="https://www.evventoz.com" />
        <link rel="canonical" href="https://www.evventoz.com" />
      </Helmet>

      <NavbarVisitor />
      <PageViewCount eventUniqueId={eventData.exhibition_unique_id} />

      <div style={{ backgroundColor: "#f3f3f3" }}>
        <div className="container">
          <div className="pt-3">
            <div className="row">
              <div className="col-md-9 text-start mb-3">
                <div className="bg-white p-2 rounded mb-3">
                  <div className="times">
                    {formatDate(eventData.exhibition_start_date)} - {formatDate(eventData.exhibition_end_date)}
                  </div>
                  <h1 className="ename">{eventData.exhibition_name}</h1>

                  <p>
                    {reviews && reviews.averageRating ? (
                      <>
                        {[...Array(5)].map((_, index) => {
                          const rating = reviews.averageRating;
                          if (index + 1 <= Math.floor(rating)) {
                            return <FontAwesomeIcon key={index} icon={faStar} className="text-success" />;
                          } else if (index < rating) {
                            return <FontAwesomeIcon key={index} icon={faStarHalfAlt} className="text-success" />;
                          } else {
                            return <FontAwesomeIcon key={index} icon={faStar} className="empty-star" />;
                          }
                        })}
                        <span className="ms-2">{`${reviews.averageRating.toFixed(1)} (${reviews.reviewCount} Ratings)`}</span>
                      </>
                    ) : (
                      <>
                        {[...Array(5)].map((_, index) => (
                          <FontAwesomeIcon key={index} icon={faStar} className="empty-star text-success" />
                        ))}
                        <span>(0 Rating)</span>
                      </>
                    )}
                  </p>

                  {eventData.venue_address && (
                    <p>
                      <MapPin size={17} /> {eventData.venue_address}
                    </p>
                  )}

                  <p>
                    <Radio size={17} />{" "}
                    {eventData.format === "ExhibitionConference" ? "Exhibition + Conference" : eventData.format || "Exhibition"}
                  </p>

                  <div className="text-start cattext mb-2 text-muted">
                    {selectedIndustries.map((industry, index) => (
                      <span key={index} className="industry-item" style={{ marginRight: "5px" }}>
                        #{industry}
                      </span>
                    ))}
                  </div>

                  <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                      <div className="mx-3">
                        {[...Array(4)].map((_, index) => (
                          <img key={index} src={defaultlogo} className="imgfluid folimg folimg2" alt="follower" />
                        ))}
                      </div>
                      <div className="followers2">{selectedFollower} Followers</div>
                    </div>
                  </div>
                </div>


                {/* Render speakers here */}
            <div className="bg-white p-1  ">

<div className="d-flex justify-content-between align-items-center mb-2">
          <div>
            <h2 className="h3clsss text-start mb-1 px-2">Partners</h2>
          </div>
           
        </div>

        <hr className="mb-2" />

<div className="row mt-2">
{partners.length > 0 ? (
                        partners.map((partner, index) => (
                          <div key={index} className="col-lg-2 col-md-3 col-6">
                            <div className="border rounded text-center ht100">
                              <div>
                                <img
                                  src={
                                    partner.profile_image
                                      ? `${IMAGE_URL}partnerFiles/${partner.profile_image}`
                                      : defaultlogo
                                  }
                                  alt={`${partner.company} Logo`}
                                  className="img-fluid my-1 evntimglogo"
                                />
                              </div>
                              <div className="nm1">
                                <strong>{partner.name}</strong>
                              </div>
                              <div className="nm1 text-muted">{partner.type}</div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <p>No partners available</p>
                      )}
</div>
</div>




              </div>
              <div className="col-md-4"></div>
            </div>

            

          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default AllPartners;
